module.exports = __webpack_public_path__ + "img/s1_bg.5dbcc618.png";